module.exports = __webpack_public_path__ + "static/ep-logo-ebcd2898da8665a828ecd224f37ebbb9.png";